import { takeLatest } from 'redux-saga/effects';

import {
    setCookie,
    deleteCookie,
} from 'helpers/CookiesHelpers';

import {
    INIT_CMP_APP,
} from '../reduxModules/ConsentManagementPlatform';

export function callAction() {
    if (document.cookie.indexOf('YPcookiecontainer') === -1) {
        setCookie('YPcookiecontainer', 0, -1);
    }

    if (document.cookie.indexOf('HOTJAR') === -1) {
        deleteCookie('_hjIncludedInSample', 0);
    }

    const gatCookie = document.cookie.match(/(_gat_UA-\d+-\d+)/);
    if (document.cookie.indexOf('GOOGLE_ANALYTICS') === -1) {
        setCookie('_ga', 0, -1);
        setCookie('_gid', 0, -1);
        setCookie(gatCookie, 0, -1);
    }

    if (document.cookie.indexOf('FACEBOOK_PIXEL') === -1) {
        const fbmCookieMatch = document.cookie.match(/(fbm_\d+)=/);
        const fbsrCookieMatch = document.cookie.match(/(fbsr_\d+)=/);
        let fbmCookie = '';
        let fbsrCookie = '';
        const matchIndex = 1;
        if (fbmCookieMatch && fbmCookieMatch.length >= 2) {
            fbmCookie = fbmCookieMatch[matchIndex];
        }
        if (fbsrCookieMatch && fbsrCookieMatch.length >= 2) {
            fbsrCookie = fbsrCookieMatch[matchIndex];
        }
        setCookie('_fbp', 0, -1);
        setCookie('_gcl_au', 0, -1);
        setCookie(fbmCookie, 0, -1);
        setCookie(fbsrCookie, 0, -1);
    }
}

export function* watch() {
    yield takeLatest(INIT_CMP_APP, callAction);
}
